import { ApolloClient } from '@apollo/client';
import { createRFXQuestionAttachment, CreateRFXQuestionAttachmentOutput, putRFXQuestion } from 'gql';
import { StringMap } from 'interfaces';
import { RFXDocumentType } from 'interfaces/RFXBackendModel';
import { RFXQuestion } from 'interfaces/RFXQuestionModel';
import { isEmpty } from 'lodash';
import { createQADocument } from 'util/questionUtils';

/**
 * Create RFI reply which can have a message and several attachments.
 *
 * @returns newly created documents information
 */
export async function createRFIReplyContent({
  apolloClient,
  question,
  stagingArns
}: {
  apolloClient: ApolloClient<object>;
  // RFX question generated from reply message
  question: RFXQuestion;
  // Staging ARNs generated from uploading files to portal staging S3
  stagingArns: StringMap | undefined;
}): Promise<CreateRFXQuestionAttachmentOutput[]> {
  await putRFXQuestion({ apolloClient, rfxQuestion: question });

  const newDocuments: CreateRFXQuestionAttachmentOutput[] = [];

  if (!isEmpty(stagingArns)) {
    for (const filename in stagingArns) {
      const stagingArn = stagingArns[filename];
      const document = createQADocument(filename, stagingArn);

      // It is important to create attachment one by one to avoid confiliction
      // There will  be "Optimistic lock error" if put all promises in an array and run Promise.all(...)
      const pendingDocument = await createRFXQuestionAttachment({
        apolloClient,
        rfxQuestionId: question.rfxQuestionRevisionedId,
        externalId: document.attachment.externalId,
        filename,
        description: '',
        stagingS3Uri: document.attachment.stagingS3Uri,
        documentType: RFXDocumentType.QA
      });

      newDocuments.push(pendingDocument);
    }
  }

  return newDocuments;
}
